"use client";

import type { ReactNode } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "ui";

/**
 * Explains why a control is disabled. Disabled buttons swallow hover, so the
 * tooltip hangs off a focusable wrapper instead of the button itself — that
 * also lets keyboard users reach it. The wrapped button is made
 * pointer-transparent so hovering it still lands on the wrapper.
 */
export default function DisabledTooltip({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            className={`inline-flex cursor-not-allowed rounded-lg [&>button]:pointer-events-none ${className ?? ""}`}
          >
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-center">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
